import MainPage from '../pages/main';
import LoginPage from '../pages/login';
import SignUpPage from '../pages/signup';
import AccountPage from '../pages/account/';
import ProcedurePage from '../pages/procedure';
import LogoutPage from '../pages/logout';
import VideoConference from '../pages/VideoConference';
import VideoPlayerPage from '../pages/VideoPlayer';

const routes =[
	{
		path:'/',
		component: MainPage,
		isPrivate: false
	},
	{
		path:'/login',
		component: LoginPage,
		isPrivate: false
	},
	{
		path:'/logout',
		component: LogoutPage,
		isPrivate: false
	},
	{
		path:'/logout/:unAuthed',
		component: LogoutPage,
		isPrivate: false
	},
	{
		path:'/r',
		component: SignUpPage,
		isPrivate: false
	},
	{
		path:'/r/:regCode',
		component: SignUpPage,
		isPrivate: false
	},
	{
		path:'/pcd',
		component: ProcedurePage,
		isPrivate: true
	},
	{
		path: '/acc/',
		component: AccountPage,
		isPrivate: true
	},
	{
		path: '/acc/:curSubPage',
		component: AccountPage,
		isPrivate: true
	},
	{
		path: '/vidconf',
		component: VideoConference,
		isPrivate: true
	},
	{
		path: '/video/:id',
		component: VideoPlayerPage,
		isPrivate: true
	},
]

export default routes